import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const deleteUser = async (userId: string): Promise<boolean> => {
  if (isMockServices()) return await mock(_mockData);

  try {
    const authTokenHttp = await getCompatibleAuthTokenHttp();
    const response = await authTokenHttp<{
      success: boolean;
    }>(`/shared/users/${userId}`, {
      method: 'DELETE',
    });
    if (response.data) return response.data.success;
    throw new Error('Failed to delete user');
  } catch (error) {
    console.error('Failed to delete user:', error);
    // Fallback
    return false;
  }
};

export default deleteUser;

const _mockData: boolean = true;
